import React, { useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from "react-router";
import { useTranslation } from 'react-i18next';
import { Location } from 'history';
import { callNativeWeb, footerShowEventWeb } from 'common/appInterface';
import { WEBVIEW_RESOURCE_VERSION } from 'common/cacheOverwrite';

/** 카드 상품별 혜택 — 약관 동의 다음, 디자인 선택 전 (Welcome·Dream·Premier) */
const CardBenefitPage: React.FC = () => {
  /** Location State */
  const location = useLocation() as Location<LocationState>;
  /** Navigate */
  const navigate = useNavigate();
  /** 다국어처리 */
  const { t, i18n } = useTranslation();

  const screenId = "APPL29";
  const screenName = t("APPL29.title", "Card Benefits");

  /** 뒤로가기 처리 (backKeyEvent_App (APP > WEB)) — 약관 동의로 이동 */
  const callbackBackkeyEvent = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  /** 디자인 선택 이동 (약관 동의값은 약관 화면에서 담아 온 state 그대로 전달) */
  const clickSelectDesign = useCallback(() => {
    navigate("/apply/cardDesignSelect", { state: location.state });
  }, [navigate, location]);

  // 최초실행
  useEffect(() => {
    // 언어설정
    i18n.changeLanguage(location.state.query.languageCode);
    // callNative_Web 처리 (WEB > APP)
    callNativeWeb(screenId, screenName);
    // 하단바 숨기기
    footerShowEventWeb("N");

    console.log("QUERY STATE");
    console.log(location.state);

    // 최초한번실행 useEffect() Warning 제거
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 뒤로가기 이벤트 리스너 (backKeyEvent_App (APP > WEB))
  useEffect(() => {
    document.addEventListener("backpress", callbackBackkeyEvent);
    return () => document.removeEventListener("backpress", callbackBackkeyEvent);
  }, [callbackBackkeyEvent]);

  return (
    <div id="wrap">
      <div id="container" className="pcHidden">
        <iframe
          className="productDetail"
          src={`${process.env.REACT_APP_OUTER_HTML_PATH}/card/benefit/${location.state.apply.cardProductCode}/issue/card_issue_benefit.html?v=${WEBVIEW_RESOURCE_VERSION}&lang=${location.state.query.languageCode}`}
          allowFullScreen={true}
          title="Card Benefit"
        />
        <div className="btnArea">
          <div className="btnWrapTy01">
            <button type="button" className="btnPrimaryTy01" onClick={clickSelectDesign}>
              <span>{t("APPL29.button01", "Select Card Design")}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardBenefitPage;
